/**
 * モックトランスクリプトリポジトリ実装
 * テストや開発用に利用するインメモリのリポジトリ
 */

import { ITranscriptRepository } from '@/repositories/interfaces';
import { MockMapRepository } from './MockMapRepository';

/**
 * モックトランスクリプトリポジトリクラス
 */
export class MockTranscriptRepository implements ITranscriptRepository {
  /**
   * コンストラクタ
   * @param mapRepository マップリポジトリの参照
   */
  constructor(private mapRepository: MockMapRepository) {}

  /**
   * トランスクリプトを取得
   */
  public async getTranscript(mapId: string): Promise<string | null> {
    const map = await this.mapRepository.getMap(mapId);
    if (!map) return null;
    
    return map.transcript;
  }

  /**
   * トランスクリプトを更新
   */
  public async updateTranscript(mapId: string, transcript: string): Promise<boolean> {
    const map = await this.mapRepository.getMap(mapId);
    if (!map) return false;

    await this.mapRepository.updateMap(mapId, { transcript });
    return true;
  }
}